function after_cf_submit(form){
    let success_html = $('.js-form-success').html();
    $('.js-form-wrapper').html(success_html);
    if(typeof dataLayer.push !== 'undefined'){
        dataLayer.push({'event': 'form_sent'});
    }
}
